var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuisnessTravelBagSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 3.79102H5.25C3.60008 3.79102 2.77513 3.79102 2.26256 4.30358C1.75 4.81614 1.75 5.6411 1.75 7.29102V8.74935C1.75 10.3992 1.75 11.2242 2.26256 11.7368C2.77513 12.2493 3.60008 12.2493 5.25 12.2493H8.75C10.3999 12.2493 11.2248 12.2493 11.7374 11.7368C12.25 11.2242 12.25 10.3992 12.25 8.74935V7.29102C12.25 5.6411 12.25 4.81614 11.7374 4.30358C11.2248 3.79102 10.3999 3.79102 8.75 3.79102Z",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3.79167V3.5C5.25 2.67504 5.25 2.26256 5.50628 2.00628C5.76256 1.75 6.17505 1.75 7 1.75C7.82495 1.75 8.23743 1.75 8.49374 2.00628C8.75 2.26256 8.75 2.67504 8.75 3.5V3.79167",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2513 6.12435C10.9627 6.12435 9.91797 5.07968 9.91797 3.79102",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39453 7L4.95703 7.4375L5.39453 7.875L5.83203 7.4375L5.39453 7Z",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 9.91602C3.03866 9.91602 4.08333 10.9607 4.08333 12.2493",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 6.12435C3.03866 6.12435 4.08333 5.07968 4.08333 3.79102",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2513 9.91602C10.9627 9.91602 9.91797 10.9607 9.91797 12.2493",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 9.80078L7.29297 9.62578L7.99297 8.92578L8.16797 9.80078Z",
    stroke: "#035865",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45703 6.41602V6.42185",
    stroke: "#035865",
    strokeWidth: 1.45833,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuisnessTravelBagSelected);
export default __webpack_public_path__ + "static/media/buisnessTravelBagSelected.c05cf36195c20c5d6a440f785d2aa591.svg";
export { ForwardRef as ReactComponent };